export default {
  toast: {},
  loading_page: false,
  show_menu: true,
  input_search_menu: "",
  is404: false,
};
